<template>
  <div class="designlist">
    <b-row>
      <b-col cols="5"></b-col>
      <b-col cols="1">
        <h1>Designs</h1>
      </b-col>
      <b-col cols="1" class="add-new-design-plus-icon">
        <router-link to="/designs/add">
          <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
        </router-link>
      </b-col>
      <b-col cols="5"></b-col>
    </b-row>
    <br />

    <!-- Loading Spinner only shows up if loading is true -->
    <b-spinner v-if="loading" label="Spinning"></b-spinner>

    <!-- No designs found shows up if loading is false, and numDesigns is 0 -->
    <h2 v-if="numDesigns == 0 && !loading">No designs have been uploaded yet. Upload one now!</h2>
    <!--  -->
    <b-container>
      <b-row class="justify-content-md-center">
        <b-col></b-col>
        <b-col cols="6">
          <!-- DesignList list shows up if loading is false, and numDesigns is greater than 0 -->
          <ul class="list-unstyled" v-if="numDesigns > 0 && !loading">
            <b-media
              id="design-media-element"
              tag="li"
              v-for="design in designs"
              :key="design.design_id"
            >
              <template v-slot:aside>
                <!-- Thumbnail. If this design has thumbnail URL defined, use that -->
                <router-link :to="'/editor/designs/' + design.design_id">
                  <b-img
                    v-if="design.thumbnail_url"
                    :src="design.thumbnail_url"
                    width="64"
                    alt="placeholder"
                  ></b-img>

                  <!-- Thumbnail. If it does NOT have thumbnail URL defined, use a blank square -->
                  <b-img
                    v-if="!design.thumbnail_url"
                    blank
                    blank-color="#007bff"
                    width="64"
                    alt="placeholder"
                  ></b-img>
                </router-link>
              </template>
              <router-link :to="'/editor/designs/' + design.design_id">
                <h5 class="mt-0 mb-1">{{design.design_name}}</h5>
              </router-link>
              <p class="mb-0">{{design.design_name}}</p>
            </b-media>
          </ul>
          <!-- Pagination shows up if loadedOnce is true and numDesigns is greater than 0 -->
          <div class="mt-3" v-if="numDesigns > 0 && loadedOnce">
            <b-pagination-nav
              use-router
              pills
              :number-of-pages="numPages"
              base-url="?page="
              align="center"
            ></b-pagination-nav>
          </div>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DesignList",
  data() {
    return {
      pageNumber: 1,
      numDesigns: -1,
      designs: [],
      loading: true,
      loadedOnce: false,

      offset: 0,
      numPages: 1,
      total: 0,

      // Max number of results per page
      limit: 5,
    };
  },
  watch: {
    $route() {
      this.loading = true;
      this.getDesigns();
    },
  },
  methods: {
    getDesigns() {
      // Get page number from query parameter
      this.pageNumber = this.$route.query.page;

      if (this.pageNumber === undefined) {
        this.pageNumber = 1;
      }

      // Based on this page number and the limit defined in data calculate the offset to be
      // sent in API call
      this.offset = (this.pageNumber - 1) * this.limit;

      // Make API call
      axios
        .get(
          process.env.VUE_APP_API_SERVER.concat(
            "/v1/designs?limit=",
            this.limit,
            "&offset=",
            this.offset
          )
        )
        .then((resp) => {
          // Update data fields with responses
          this.designs = resp.data.data;
          this.numDesigns = resp.data.data.length;
          this.total = resp.data.meta.total;

          // Calculate the number of pages to show up in pagination using the formula:
          //     total_number_of_results / limit
          // limit is the max number of results that will be returned by the API.
          this.numPages = Math.ceil(this.total / this.limit);

          // If someones manually puts a very high number as the page in the query param
          // default back to the last page for this result set
          if (this.numDesigns == 0 && this.total > 0) {
            this.$router
              .push({ path: "/designs", query: { page: this.numPages } })
              .catch((err) => {
                alert(err);
              });
            return;
          }

          // Calculate the number of pages to show up in pagination using the formula:
          //     total_number_of_results / limit
          // limit is the max number of results that will be returned by the API.
          this.numPages = Math.ceil(this.total / this.limit);
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          // Sleep for 10ms to give the loading icon a chance to show up
          setTimeout(() => {
            this.loading = false;
          }, 50);
        });
    },
  },
  mounted() {
    // If user navigated directly to /designs without page query param,
    // catch that and fix
    if (this.$route.query.page === undefined) {
      this.$router.push({ path: "/designs", query: { page: "1" } });
    }

    // get the designs
    this.getDesigns();

    // set loadedOnce to true so that pagination shows up and stays on
    // route changes
    this.loadedOnce = true;
  },
};
</script>

<style scoped>
#design-media-element {
  text-align: left;
  margin-bottom: 20px;
}

.add-new-design-plus-icon {
  display: flex;
  vertical-align: baseline;
  align-items: center;
}
</style>
